module.exports = __webpack_public_path__ + "img/adminServiceInfo1_back_2023_10_04.65373808.png";